export const enum DeliveryServiceVersion {
  ONE = 1,
  TWO = 2,
}
